export const errorMessages = {
  REQUIRED_FIELD: "required",
  INVALID_PHONE_NUMBER:
    "Invalid phone number. Please enter a valid phone number",
  PHONE_NUMBER_LENGTH: "Phone number must be between 7 and 15 characters",
  INVALID_EMAIL_OR_PHONE: "Please enter a valid email or phone number",
  INVALID_URL: "invalidUrl",
  ERROR_OCCURRED: "An error occurred",
  UNKNOWN_ERROR_OCCURRED: "An unknown error occurred",
  COULD_NOT_FIND_THIS_PAGE: "Could not find this page",
  INVALID_OPTION: "Invalid Option",
  SOMETHING_WENT_WRONG: "Something Went Wrong",
  FAILED_RESET_PASSWORD: "Failed to Reset Password",
  PERMISSION_DENIED: "Your account has been rejected by an administrator. Please contact support.",
  LOGIN_FAILED: "Login Failed",
  FAILED_PROFILE_IMAGE_UPLOAD: "Failed To Upload Profile Picture",
  FAILED_GOOGLE_SIGNIN: "An Error Occured While Redirecting to Google",
  INVALID_NUMBER: "Invalid Number",
  INVALID_OPTION: "Invalid Option",
  INVALID_ID_NUMBER: "Invalid ID format.", // Use GHA-XXXXXXXXX-X.",
  INVALID_DATE: "Invalid Date",
  INVALID_TIME: "Invalid Time",
  SUSPENDED_ACCOUNT:
    "Your account has been suspended. Please contact support for more information.",
  FAILED_BANK_VERIFICATION:
    "Failed to verify bank account. Please check your bank account number and try again.",
  FAILED_MOBILE_MONEY_VERIFICATION:
    "Failed to verify mobile money information. Please check your mobile money payout details and try again.",
  FIRST_NAME_REQUIRED: "firstName",
  INVALID_FIRST_NAME: "fname1",
  LAST_NAME_REQUIRED: "lname",
  INVALID_LAST_NAME: "lname1",
  USERNAME_REQUIRED: "uname",
  INVALID_USERNAME: "uname1",
  COUNTRY_REQUIRED: "Please enter Country",
  STATE_REQUIRED: "Please enter State/Province",
  PASSWORD_REQUIRED: "password",
  INVALID_PASSWORD: "password1",
  REQUIRED_FIELD_PASSWORD: "confirmPassword",
  PASSWORD_MISMATCH: "confirmPassword1",
 

  INVALID_DJNAME: "DJ Name contains invalid characters. Please use digits, letters, dash, and underscore",
  EMAIL_ALREADY_EXISTS: "email2",
  EMAIL_REQUIRED: "email",
  INVALID_EMAIL: "email1",
  
};



// export const errorMessages = {
//   REQUIRED_FIELD: "This field is required",
//   INVALID_PHONE_NUMBER:
//     "Invalid phone number. Please enter a valid phone number",
//   PHONE_NUMBER_LENGTH: "Phone number must be between 7 and 15 characters",
//   INVALID_EMAIL_OR_PHONE: "Please enter a valid email or phone number",
//   INVALID_EMAIL: "Please enter a valid email address",
//   INVALID_URL: "Please enter a valid URL",
//   INVALID_PASSWORD:
//     "Password must be at least 6 characters.",
//   PASSWORD_MISMATCH: "Passwords do not match",
//   ERROR_OCCURRED: "An error occurred",
//   UNKNOWN_ERROR_OCCURRED: "An unknown error occurred",
//   COULD_NOT_FIND_THIS_PAGE: "Could not find this page",
//   INVALID_OPTION: "Invalid Option",
//   SOMETHING_WENT_WRONG: "Something Went Wrong",
//   FAILED_RESET_PASSWORD: "Failed to Reset Password",
//   PERMISSION_DENIED: "Your account has been rejected by an administrator. Please contact support.",
//   LOGIN_FAILED: "Login Failed",
//   FAILED_PROFILE_IMAGE_UPLOAD: "Failed To Upload Profile Picture",
//   FAILED_GOOGLE_SIGNIN: "An Error Occured While Redirecting to Google",
//   INVALID_NUMBER: "Invalid Number",
//   INVALID_OPTION: "Invalid Option",
//   INVALID_ID_NUMBER: "Invalid ID format.", // Use GHA-XXXXXXXXX-X.",
//   INVALID_DATE: "Invalid Date",
//   INVALID_TIME: "Invalid Time",
//   SUSPENDED_ACCOUNT:
//     "Your account has been suspended. Please contact support for more information.",
//   FAILED_BANK_VERIFICATION:
//     "Failed to verify bank account. Please check your bank account number and try again.",
//   FAILED_MOBILE_MONEY_VERIFICATION:
//     "Failed to verify mobile money information. Please check your mobile money payout details and try again.",
//   // FIRST_NAME_REQUIRED: "Please enter your First Name",
//   FIRST_NAME_REQUIRED: "firstName",
//   // INVALID_FIRST_NAME: "First Name must contain only letters,hyphens and apostrophes",
//   INVALID_FIRST_NAME: "fname1",
//   // LAST_NAME_REQUIRED: "Please enter your Last Name",
//   LAST_NAME_REQUIRED: "lname",
//   // INVALID_LAST_NAME: "Last Name must contain only letters,hyphens and apostrophes",
//   INVALID_LAST_NAME: "lname1",
//   EMAIL_REQUIRED: "Please enter valid Email",
//   // USERNAME_REQUIRED: "Please enter valid Username. It must contain at least 6 characters",
//   USERNAME_REQUIRED: "uname",
//   PASSWORD_REQUIRED: "Please enter Password",
//   COUNTRY_REQUIRED: "Please enter Country",
//   STATE_REQUIRED: "Please enter State/Province",

//   // INVALID_USERNAME: "Username contains invalid characters. Please use digits, letters, dash, and underscore",
//   INVALID_USERNAME: "uname1",
//   INVALID_DJNAME: "DJ Name contains invalid characters. Please use digits, letters, dash, and underscore",
//   EMAIL_ALREADY_EXISTS: "Email already exists. Please use a different email.",
// };

